"use client"
const ConfirmSwapModal = ({
  widgetState,
  setWidgetState,
  setActionButtonLabel,
  apiCallInProgress,
  amount,
  tokenSellSelected,
  blockChainSellSelected,
  tokenBuySelected,
  blockChainBuySelected,
  selectedRoute,
  actionButtonHandler,
  actionButtonLabel,
  handleClick,
  address
}) => {
  if (widgetState !== "ConfirmSwap") return null

  return (
    <div className={`rango-select-widget ${widgetState === "ConfirmSwap" ? "show" : ""}`}>
      <div className="d-flex flex-column justify-content-between rango-selected-widget">
        <div>
          <div className="rango-flex rango-flex--between">
            <div
              className="rango-icon"
              onClick={() => {
                if (apiCallInProgress) return
            
                setWidgetState("SelectSwapPair")
                setActionButtonLabel("Find Routes")
            
                if (typeof handleClick === "function") {
                  handleClick()
                }
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
              </svg>
            </div>
            <div className="rango-title">Confirm Swap</div>
            <div />
          </div>
          <div className="text-center">
            Review your swap details and hit confirm to start process.
          </div>
          <div className="scroll-item-swap my-4">
            <div className="flex-1">
              <div className="item" style={{ fontSize: "11px" }}>
                <strong style={{ fontSize: "18px" }}>{parseFloat(amount).toFixed(3)}</strong>
                <br />
                {tokenSellSelected.symbol} [{blockChainSellSelected.name}]
              </div>
            </div>
            <div className="item-connect--between flex-1 mx-3">
              <div className="divider" />
            </div>
            <div className="flex-1">
              <div className="item" style={{ fontSize: "11px" }}>
                <strong style={{ fontSize: "18px" }}>
                  {Number.parseFloat(selectedRoute?.outputAmount || "0").toFixed(3)}
                </strong>
                <br />
                {tokenBuySelected.symbol} [{blockChainBuySelected.name}]
              </div>
            </div>
          </div>

          <div className="rango-setting-widget d-flex align-items-center rango-flex--between gap-2">
            <div className="wallet-item">
              <label className="m-0">From KAXA Wallet</label>
            </div>
            <i>{address}</i>
          </div>
        </div>

        <div>
          <button
            onClick={actionButtonHandler}
            className={`${apiCallInProgress ? "rango-connect--wallet-disabled" : "rango-connect--wallet"}`}
          >
            {actionButtonLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmSwapModal
